import { render, staticRenderFns } from "./GuangzhouTelecom2.vue?vue&type=template&id=07cd9c5d&scoped=true"
import script from "./GuangzhouTelecom2.vue?vue&type=script&lang=js"
export * from "./GuangzhouTelecom2.vue?vue&type=script&lang=js"
import style0 from "./GuangzhouTelecom2.vue?vue&type=style&index=0&id=07cd9c5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cd9c5d",
  null
  
)

export default component.exports